/**
 * App foreground/resume port — browser tab visibility.
 */
export const subscribeToAppForeground = (onForeground: () => void): (() => void) => {
  const onVisibility = (): void => {
    if (document.visibilityState === 'visible') {
      onForeground();
    }
  };
  document.addEventListener('visibilitychange', onVisibility);
  return () => document.removeEventListener('visibilitychange', onVisibility);
};
